<template>
  <div class="progress-wrap" v-if="bLoading">
    <div>
      <div class="box">
        <div class="num">
          pdf生成中......
          <span>{{ nLoading }}%</span>
        </div>
        <div class="progress">
          <div :style="{ width: nLoading + '%' }"></div>
        </div>
        <div class="text">
          文件较大，预计需要1分钟，请耐心等待!
        </div>
      </div>
      <div class="bg"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bLoading: {
      type: Boolean,
      default: false,
    },
    nLoading: {
      type: Number,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.progress-wrap {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #ffffff;
  margin: auto;
  z-index: 9999;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  .box {
    text-align: center;
    // justify-content: space-between;
    height: 0.5rem;
    margin: auto;
    width: 7rem;
    .num {
      height: inherit;
      color: #131313;
      font-size: 0.4rem;
      line-height: 0.5rem;
      height: 0.5rem;
      background-color: transparent;
      margin-left: 0.2rem;
      text-align: center;
      margin-bottom: 0.26rem;
    }
    .text{
      height: inherit;
      color: #131313;
      font-size: 25px;
      line-height: 0.5rem;
      height: 0.5rem;
      background-color: transparent;
      margin-left: 0.2rem;
      text-align: center;
      margin-top: 0.26rem;
    }
  }
  .bg {
    width: 8.27rem;
    height: 5.2rem;
    background: url(~@/assets/images/ant/progress_bg.png) no-repeat center/100%
      100%;
    margin: 2.57rem auto 0;
  }
  .progress {
    height: 0.5rem;
    width: 7rem;
    background-color: #d6d6d6;
    div {
      height: inherit;
      background-color: #2456ba;
      max-width: 7rem;
      transition: all 0.5s;
      width: 0;
    }
  }
}
</style>